if (!customElements.get("nmn-product")) {
  customElements.define(
    "nmn-product",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.mediaController?.abort();
        this.fitObserver?.disconnect();
        cancelAnimationFrame(this.fitFrame);
        this.controller = new AbortController();
        this.form = this.querySelector("product-form form");
        if (!this.form) return;
        this.connectPurchaseFit();
        if (this.dataset.offerLayout === "original") {
          this.connectOriginal();
          return;
        }
        if (this.dataset.showVariantImage === "true") {
          this.addEventListener("change", (event) => {
            if (event.target.matches("[data-variant-select], [data-offer], [data-once]")) {
              this.updateVariantMedia();
            }
          }, { signal: this.controller.signal });
        }
      }
      async updateVariantMedia() {
        this.mediaController?.abort();
        this.mediaController = new AbortController();
        const { signal } = this.mediaController;
        const variantId = this.form.elements.id.value;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variantId);
        url.searchParams.delete("selling_plan");
        url.searchParams.set("section_id", this.dataset.section);
        try {
          const response = await fetch(url.href, { signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), "text/html");
          if (signal.aborted || !this.isConnected || this.form.elements.id.value !== variantId) return;
          for (const selector of ["media-gallery", "product-modal"]) {
            const current = this.querySelector(selector);
            const replacement = html.querySelector(selector);
            if (current && replacement) current.replaceWith(replacement);
          }
        } catch (error) {
          if (error.name !== "AbortError") console.error(error);
        }
      }
      connectPurchaseFit() {
        const container = this.querySelector(".nmn-product__fit-container");
        const information = this.querySelector(".nmn-product__information");
        const submit = this.form.querySelector('[type="submit"]');
        if (!container || !information || !submit) return;
        const schedule = () => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => {
            container.style.removeProperty("--nmn-purchase-fit");
            container.style.removeProperty("--nmn-purchase-overflow");
            container.style.removeProperty("--nmn-purchase-top");
            if (!window.matchMedia("(min-width: 750px)").matches) return;
            // Measure relative to the column's resting/sticky top, not its
            // current scrolled position, so scrolling never flips the layout.
            const header = parseFloat(getComputedStyle(this).getPropertyValue("--nmn-header-height")) || 98;
            const available = window.innerHeight - header - 34 - 16;
            const fits = () => submit.getBoundingClientRect().bottom - information.getBoundingClientRect().top <= available;
            if (!fits()) container.style.setProperty("--nmn-purchase-fit", "compact");
            if (!fits()) container.style.setProperty("--nmn-purchase-fit", "scroll");
            if (!fits()) {
              const heightThroughButton = submit.getBoundingClientRect().bottom - information.getBoundingClientRect().top;
              container.style.setProperty("--nmn-purchase-top", `${window.innerHeight - heightThroughButton - 16}px`);
              container.style.setProperty("--nmn-purchase-overflow", "true");
            }
          });
        };
        this.fitObserver = new ResizeObserver(schedule);
        this.fitObserver.observe(information);
        this.fitObserver.observe(this.form);
        window.addEventListener("resize", schedule, { signal: this.controller.signal });
        this.addEventListener("change", schedule, { signal: this.controller.signal });
        schedule();
      }
      connectOriginal() {
        this.addEventListener(
          "change",
          (event) => {
            if (event.target.matches("[data-variant-select]")) {
              const url = new URL(window.location.href);
              url.searchParams.set("variant", event.target.value);
              url.searchParams.delete("selling_plan");
              window.location.assign(url.href);
            }
            if (event.target.matches('[name="selling_plan"]')) {
              const button = this.form.querySelector('[type="submit"]');
              if (!button.disabled)
                this.querySelector("[data-submit-label]").textContent =
                  `${window.variantStrings.addToCart} — ${event.target.dataset.price}`;
            }
          },
          { signal: this.controller.signal },
        );
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.mediaController?.abort();
        this.fitObserver?.disconnect();
        cancelAnimationFrame(this.fitFrame);
      }
    },
  );
}
